// src/components/News/News.jsx
import React from 'react';
import './News.css';

const News = () => {
  return (
    <div className="news-sectionyy">
      <h2>Upcoming News</h2>
      <div className="news-contentyy">
        <div className="news-textyy">
          <h3>New App Launch Soon</h3>
          <p>
            We are going to launch the app for you very soon and teachers of these subjects are also joining us, through whom online astrology, Vedic astrology, palmistry, Krishnamurti method, Parashar method, tarot card, face reading, yoga, healing, numerology, Apart from this, we are going to start online classes of education related Maths, Bio, Physics, Chemistry, English on Vaastu Shastra, Rituals, Yajurveda, Sanskrit.
            <br />
            <strong>Pt Jaideep Sharma</strong> <br />
            9826190941, 9826200941<br />
            <strong>Pt Kapil Sharma</strong> <br />
            8269950777, 7587636218
          </p>
        </div>
      </div>
    </div>
  );
};

export default News;
